import FundingCard from "./component";

export default FundingCard;
